/* 
Object:         Node
Description:    Logic and events for the module NodeRoles
Used in:        Node
*/

import * as appsettings from "../appsettings";
import * as listbox from "../listbox";

var _msg_notsaved = "";

/**
* Init nodeRoles
* @param {string} notsaved
*/
export function initialize(notsaved: string): void {
    _msg_notsaved = notsaved;
}

/**
* Return label changed not saved
*/
export function getLDataChangedNotSavedYet(): string {
    return _msg_notsaved;
}

/**
* Enable save button
*/
export function enableSaveButton(): void {
    $("#saveButtonRoles").data("kendoButton").enable(true);
}

/**
* Disable save button
*/
export function disableSaveButton(): void {
    $("#saveButtonRoles").data("kendoButton").enable(false);
}

/**
* roles - Left clicked
*/
export function leftClicked(): void {
    enableSaveButton();
    listbox.moveItems("Node_Roles_CplSelected", "Node_Roles_CplNotSelected", "#Roles_Validation", getLDataChangedNotSavedYet());
}

/**
* Tab roles - Right clicked
*/
export function rightClicked(): void {
    enableSaveButton();
    listbox.moveItems("Node_Roles_CplNotSelected", "Node_Roles_CplSelected", "#Roles_Validation", getLDataChangedNotSavedYet());
}

/**
* Tab roles - Save button clicked
* @param {string} actionUrl
* @param {number} nodeId
*/
export function saveButtonClicked(actionUrl: string, nodeId: number): void {

    disableSaveButton();

    const json = $("#Node_Roles_CplSelected").data("kendoListBox").dataSource.view().toJSON();
    const list = json.slice();

    $.ajax({
        type: "POST",
        url: appsettings.getUrl(actionUrl),
        data: { list: kendo.stringify(list), id: nodeId },
        success: function (responseData) {

            $('#Roles_Validation').text("");

            var color = (responseData.Success ? 'green' : 'red');
            $('#Roles_Validation').text(responseData.Message);
            $('#Roles_Validation').attr('style', 'color:' + color);
        }
    });
}
